module.exports = __webpack_public_path__ + "img/MichaelGrimm_140x140_rund.d23be840.jpg";